import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Row, Col } from 'reactstrap';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

const Session = ({ children }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [language, setLanguage] = useState('');

    const [seed, setSeed] = useState(0);
    const [logged, setLogged] = useState(false);
    const [displayName, setDisplayName] = useState(false);
    const [administrators, setAdministrators] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            setLogged(true);
        } else {
            const timeout = setTimeout(() => {
                let redirectUrl = '/login';
                window.location.href = redirectUrl;
                navigate(redirectUrl);
            }, 200);
        }
    }, [navigate]);

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            setDisplayName(JSON.parse(currentSession)?.displayName);
            let groups = JSON.parse(currentSession)?.session?.groups;
            if (groups && groups && groups?.length > 0) {
                Object.values(groups).forEach(item => {
                    if (item?.name === 'Administrators') {
                        setAdministrators(true);
                    }
                });
            }
            setSeed(Math.random());
            setLogged(true);
        } else {
            setSeed(Math.random());
            setLogged(false);
        }
    }, []);

    useEffect(() => {
        if (((logged && logged) === true) && ((administrators && administrators) === false)) {
            const timeout = setTimeout(() => {
                let redirectUrl = '/logout';
                window.location.href = redirectUrl;
                navigate(redirectUrl);
            }, 200);
        }
    }, [navigate, logged, administrators]);


    return (
        <React.Fragment>
            {children && children}
        </React.Fragment >
    )
};

export default Session;